<template>
  <v-dialog max-width="400" persistent v-model="show">
    <v-card>
      <v-card-title
        ><span class="title">{{ title }}</span></v-card-title
      >
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                :label="$t('fields.name') + '*'"
                outline
                required
                v-model="voter.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :label="$t('fields.surname') + '*'"
                outline
                required
                v-model="voter.surname"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :label="$t('fields.email') + '*'"
                outline
                required
                v-model="voter.email"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :hint="$t('labels.mobileHint')"
                :label="$t('fields.mobile') + (sms_authentication ? '*' : '')"
                outline
                required
                v-model="voter.mobile"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <TagsPopup
                :ajax="true"
                :data="'voters'"
                :label="$t('fields.tags')"
                v-model="voter.tags"
              ></TagsPopup>
            </v-flex>
            <v-flex v-show="weighted" xs12>
              <CurrencyField
                :label="$t('fields.weight')"
                required
                v-model="voter.weight"
              ></CurrencyField>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error">{{ $t('buttons.close') }}</v-btn>
        <v-btn @click="save" color="success">{{ $t('buttons.save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CurrencyField from '@/components/trinkets/CurrencyField.vue'
import TagsPopup from '@/components/trinkets/TagsPopup.vue'
import Voter from '@/models/Voter.js'
import { v4 as uuidv4 } from 'uuid'

export const ACTION_CREATE = 'create'
export const ACTION_EDIT = 'edit'

export default {
  components: {
    CurrencyField,
    TagsPopup,
  },

  props: {
    value: Boolean,
    voterProp: Voter,
    weighted: Boolean,
    sms_authentication: Boolean,
    title: String,
    checkEmailDomain: Function,
    action: {
      default: ACTION_CREATE,
      type: String,
    },
  },

  data() {
    return {
      voter: new Voter(this.voterProp),
    }
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    value: function () {
      this.voter = new Voter(this.voterProp)
    },
  },

  methods: {
    close() {
      this.show = false
    },

    save() {
      let message = ''

      if (this.voter.name == '') {
        message += this.$t('alerts.firstnameMissing') + '<br />'
      } else {
        if (this.voter.name.length < 2) {
          message += this.$t('alerts.nameLength') + '<br />'
        }
      }

      if (this.voter.surname == '') {
        message += this.$t('alerts.surnameMissing') + '<br />'
      } else {
        if (this.voter.surname.length < 2) {
          message += this.$t('alerts.surnameLength') + '<br />'
        }
      }

      if (this.voter.email == '') {
        message += this.$t('alerts.emailMissing') + '<br />'
      } else {
        if (!this.$checkEmail(this.voter.email)) {
          message += this.$t('alerts.emailVerification') + '<br />'
        } else {
          if (!this.checkEmailDomain(this.voter.email)) {
            message += this.$t('alerts.emailDomain') + '<br />'
          }
        }
      }

      if (this.voter.weight == 0) {
        message += this.$t('alerts.invalidWeight') + '<br />'
      }

      if (this.sms_authentication) {
        if (this.voter.mobile == '') {
          message += this.$t('alerts.mobileMissing') + '<br />'
        }
      }

      if (this.voter.mobile != '') {
        if (!this.$checkPhoneFormat(this.voter.mobile)) {
          message += this.$t('alerts.mobileFailFormat') + '<br />'
        }
        if (this.voter.mobile.charAt(0) === '0') {
          this.voter.mobile = this.voter.mobile.replace('0', '+385')
        }
      }

      if (message != '') {
        this.$alert(message)

        return
      }

      // Converts Email to lowercase.
      this.voter.email = this.voter.email.toLowerCase()

      if (this.action === ACTION_CREATE) {
        this.voter.id = uuidv4()
        this.$emit('voter-store', new Voter(this.voter))

        return
      }

      this.$emit('voter-update', new Voter(this.voter))
    },
  },
}
</script>
